// removed by extract-text-webpack-plugin
module.exports = {"radar":"antd-pro-charts--radar-radar","legend":"antd-pro-charts--radar-legend","legendItem":"antd-pro-charts--radar-legendItem","dot":"antd-pro-charts--radar-dot"};


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/src/components/Charts/Radar/index.less
// module id = 610
// module chunks = 0